import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import { useLocation } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import moment from "moment";
import { isMobile, MobileView, BrowserView } from "react-device-detect";
import jwt_decode from "jwt-decode";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";

import InfoPill from "../InfoPill";

import { Helmet } from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import trasportApi from "../../api/trasportApi";
import { ROUTES } from "../../constants/WebRouting";
import { formatDate } from "../../utils/helper";
import Main from "../layout/Main";

const LeadList = () => {
  // const location = useLocation();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  // const [leadname, setProjectName] = useState();
  // const[contact,setContact] = useState(location.state ? location.state : {});
  // const [lead, setProject] = useState();
  // const [userInfo, setUserInfo] = useState({});
  //////console.log('location.state ='+location.state)
  const [projectStatusArray, setProjectStatusArray] = useState(
    constants.Project_Stage_Status
  );

  // useEffect(() => {
  //   // setUserInfo(jwt_decode(localStorage.getItem('token')));

  //   async function init() {
  //     const products = await trasportApi?.fetchProducts();
  //     console.log('products',products);
  //     if (products) {
  //       setBody(products);
  //     } else {
  //       setBody([]);
  //     }
  //   }
  //   init();
  // }, []);

  useEffect(() => {
    const init = async () => {
      try {
        const products = await trasportApi?.fetchProducts();
        console.log("products", products);
        setBody(Array.isArray(products) ? products : []);
      } catch (error) {
        console.error("Error fetching products:", error);
        setBody([]); // fallback empty array
      }
    };

    init();
  }, []);

  // Create table headers consisting of 4 columns.
  const header = [];

  if (!isMobile) {
    header.push(
      {
        title: "Product Name",
        prop: "product_name",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={`${ROUTES.PRODUCT.LIST}/${row.id}`} state={row}>
            {row.product_name}
          </Link>
        ),
      },

      {
        title: "Category",
        prop: "name",
        isFilterable: true,
      },
      {
        title: "Brand Name",
        prop: "brand_name",
        isFilterable: true,
      },
      // {
      //   title: "Product Remark",
      //   prop: "product_description",
      //   isFilterable: true,
      // },
      {
        title: "Created Date",
        prop: "createddate",
        isSortable: true,
        isFilterable: true,
        cell: (row) => <span>{formatDate(row.createddate)}</span>,
      },
      {
        title: "Last Modified Date",
        prop: "lastmodifieddate",
        isSortable: true,
        isFilterable: true,
        cell: (row) => <span>{formatDate(row.lastmodifieddate)}</span>,
      },
    );
  } else {
    //for mobile device

    header.push({
      title: "Info",
      prop: "product_name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.PRODUCT.LIST}/${row.id}`}
            state={row}
            style={{ fontSize: "1.2rem" }}
          >
            {row.leadname}
          </Link>
        </div>
      ),
    });
  }

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createProject = () => {
    navigate(`/products/e`);
  };

  return (
    <>
      <Main>
        <Container fluid>
          <Row className="">
            <Col lg={12} className="">
              <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 15,
                    options: [5, 10, 15, 20],
                  },
                }}
              >
                <Row className="">
                  <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                  >
                    <Filter
                      classes={{
                        inputGroup: "",
                        input: "",
                        clearButton: "btn-custom",
                      }}
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    lg={5}
                    className="d-flex flex-col justify-content-start align-items-center"
                  >
                    <PaginationOptions labels={labels} />

                    <BrowserView className="mx-5 mt-4">
                      <InfoPill left="Total" right={body?.length} />
                    </BrowserView>
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    lg={3}
                    className="d-flex flex-col justify-content-end align-items-end"
                  >
                    <Button
                      size="sm"
                      className="btn-create"
                      onClick={() => createProject(true)}
                    >
                      New Product
                    </Button>
                  </Col>
                </Row>
                <Table striped className="shadow rounded sm my-4 data-table" responsive={true}>
                  <TableHeader />
                  {body && Array.isArray(body) ? (
                    <TableBody />
                  ) : (
                    <tbody className="">
                      <tr>
                        <td colSpan={100} align="center">
                          <div>
                            <Spinner />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
                <Pagination
                  classes={{
                    buttonGroup: "",
                    button: "bg-custom border-white",
                  }}
                />
              </DatatableWrapper>
            </Col>
          </Row>
        </Container>
      </Main>
    </>
  );
};
export default LeadList;
